import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import Header from '@components/header'
import { columnItemsShapesAdmin } from '@utils/columns'
import { getToday } from '@utils/time'
import { Table } from 'antd'
import Layout from '@components/Layout'
import { useQuery } from '@tanstack/react-query'
import { debouncedSet } from '@utils/debounce'
import { http } from '@services/http'
import EditShapesTableModal from '@components/Modal/editShapesTableModal'

const ItemsShapes = () => {
	const { t } = useTranslation()
	const formattedDate = getToday()

	const [isModalVisible, setIsModalVisible] = useState(false)
	const [isViewModalVisible, setIsViewModalVisible] = useState(false)
	const [selectedRowData, setSelectedRowData] = useState(null)
	const [selectedViewRowData, setSelectedViewRowData] = useState(null)
	const [currentPage, setCurrentPage] = useState(0)
	const [itemName, setItemName] = useState('')
	const [itemCode, setItemCode] = useState('')
	const [category, setCategory] = useState('')
	const [itemType, setItemType] = useState('')
	const [itemsData, setItemsData] = useState([])
	const [hasMore, setHasMore] = useState(true)

	const tableContainerRef = useRef(null)

	const fetchItems = async ({ queryKey }) => {
		const [_, itemName, itemCode, category, itemType, page] = queryKey
		try {
			let url = `api/items/get-items?itemName=${itemName}&categories=107&pageSize=30&pageToken=${page}`
			const { data } = await http.get(url)
			return data.data
		} catch (error) {
			console.log(error)
		}
	}

	const {
		data = [],
		isLoading,
		refetch,
	} = useQuery({
		queryKey: [
			'itemsShapes',
			itemName,
			itemCode,
			category,
			itemType,
			currentPage,
		],
		queryFn: fetchItems,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	useEffect(() => {
		if (data?.length > 0) {
			setItemsData((prev) =>
				currentPage === 0 ? data : [...prev, ...data],
			)
			setHasMore(data.length === 30)
		} else {
			setHasMore(false)
		}
	}, [data, currentPage])

	const handleScroll = (e) => {
		const { scrollTop, scrollHeight, clientHeight } = e.target
		const isBottom = scrollHeight - scrollTop <= clientHeight + 100
		if (isBottom && hasMore && !isLoading) {
			setCurrentPage((prev) => prev + 1)
		}
	}

	const handleNextPage = () => {
		if (data.length === 10) {
			setCurrentPage((prevPage) => prevPage + 1)
		}
	}

	const handlePreviousPage = () => {
		if (currentPage > 0) {
			setCurrentPage((prevPage) => prevPage - 1)
		}
	}

	const handleRowClick = (record) => {
		setSelectedRowData(record)
		setIsModalVisible(true)
	}
	const handleViewRowClick = (record) => {
		setSelectedViewRowData(record)
		setIsViewModalVisible(true)
	}

	const handleItemCodeChange = (val) => {
		debouncedSet(val, setItemCode)
	}

	const handleItemNameChange = (val) => {
		setCurrentPage(0)
		setItemsData([])
		debouncedSet(val, setItemName)
	}

	const columns = columnItemsShapesAdmin(
		t,
		handleViewRowClick,
		handleItemCodeChange,
		handleItemNameChange,
	)

	return (
		<Layout>
			{/* <Header
				title={'shapes'}
				currentPage={currentPage + 1}
				handlePreviousPage={handlePreviousPage}
				handleNextPage={handleNextPage}
				hasMoreData={data.length === 10}
				columns={columns}
				fdata={data}
				loading={isLoading}
				formattedDate={formattedDate}
				isSticky={false}
			/> */}
			<div className="m-5 border-[2px] border-gray-200 rounded-lg">
				<div className="flex  justify-between items-center ml-10 mr-10 mt-6">
					<h1 className="font-poppins text-xl font-bold text-black">
						{t('shapes')}
					</h1>
				</div>

				<div
					ref={tableContainerRef}
					onScroll={handleScroll}
					style={{
						height: '70vh',
						overflowY: 'auto',
						margin: '20px',
					}}
				>
					<Table
						columns={columns}
						dataSource={itemsData}
						pagination={false}
						bordered
						rowKey="Code"
						loading={isLoading}
						sticky
					/>
				</div>
			</div>
			<EditShapesTableModal
				visible={isViewModalVisible}
				data={selectedViewRowData}
				onClose={() => {
					setIsViewModalVisible(false)
				}}
				onSuccess={() => {
					setCurrentPage(0)
					setItemsData([])
					refetch()
				}}
			/>
		</Layout>
	)
}

export default ItemsShapes
